import GA from './analysis'
import axios from 'axios'
import moment from 'moment'
import Cookies from 'js-cookie'
import Vue from 'vue'
import config from '../config'

export default {
  /*
  * search query parameter from current url
  *
  * @paramName key
  * @return
  *   paramName == false: object include all params
  *   paramName != false: value for input paramName
  */
  getCurUrlParameter: (paramName) => {
    if (!paramName) {
      let result = {}
      if (!window) return result
      let searchString = window.location.search.substring(1)
      let params = searchString.split('&')
      for (let i = 0; i < params.length; i++) {
        let val = params[i].split('=')
        result[val[0]] = val[1]
      }
      return result
    } else {
      if (!window) return null
      let searchString = window.location.search.substring(1)
      let params = searchString.split('&')
      for (let i = 0; i < params.length; i++) {
        let val = params[i].split('=')
        if (val[0] === paramName) {
          return val[1]
        }
      }
      return null
    }
  },

  /**
   * 获取 url 中的参数
   *
   * 输入页面地址，获取某一个指定参数的值
   *
   * @param    {string}  link 要获取参数的页面地址
   * @param    {string}  key  要获取的参数
   * @return   {string}       获取到参数的值
   */
  getQueryString: (link, key) => {
    const reg = new RegExp('(^|&)' + key + '=([^&]*)(&|$)', 'i')
    const queryString = link.split('?').length > 1 ? link.split('?')[1] : ''
    const r = queryString.match(reg)
    if (r !== null) return decodeURIComponent(r[2])
    return ''
  },

  /**
   * 获取 url 中存储的 ticket
   *
   * @return  {string}
   */
  getTicket: function () {
    return this.getQueryString(window.location.href, 'ticket')
  },

  /**
   * 获取 url 中存储的 deviceId
   *
   * @return  {string}
   */
  getDeviceId: function () {
    return this.getQueryString(window.location.href, 'deviceId')
  },

  isInApp: () => {
    return (this.getQueryString(window.location.href, 'deviceId') || !!navigator.userAgent.match(/org\.geekbang\.GeekTime/i))
  },

  isMobile: () => {
    var ua = navigator.userAgent
    var isAndroid = /Android/i.test(ua)
    var isBlackBerry = /BlackBerry/i.test(ua)
    var isWindowPhone = /IEMobile/i.test(ua)
    var isIOS = /iPhone|iPad|iPod/i.test(ua)
    var isMobile = isAndroid || isBlackBerry || isWindowPhone || isIOS
    return isMobile
  },

  isIOS: () => {
    return !!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
  },

  /**
   * 是否在微信小程序内
   * [同步方式非异步]
   * @return {boolean} 如果是微信环境则返回 true
   */
  isInWXMiniProgram: () => {
    return (
      (window.__wxjs_environment && window.__wxjs_environment === 'miniprogram') || window.navigator.userAgent.toLowerCase().indexOf('miniprogram') > -1
    )
  },

  /**
   * 微信分享设置
   */
  initWxConfig () {
    return new Promise((resolve, reject) => {
      if (!this.isInWeixin()) {
        resolve()
        return
      }

      const url = window.location.href

      axios({
        type: 'get',
        url: `https://misc.geekbang.org/wxmisc/wxshare/sign?url=${encodeURIComponent(url)}&mpid=gh_a4dbefba05a2`
      })
        .then(res => {
          let response = res.data.data
          try {
            window.wx.config({
              debug: false,
              appId: response.appId, // 必填，公众号的唯一标识
              timestamp: String(response.timestamp), // 必填，生成签名的时间戳
              nonceStr: response.nonceStr, // 必填，生成签名的随机串
              signature: response.signature, // 必填，签名，见附录1
              jsApiList: ['getLocation', 'openLocation', 'onMenuShareTimeline', 'onMenuShareAppMessage', 'chooseWXPay', 'onMenuShareQQ', 'onMenuShareWeibo', 'onMenuShareQZone', 'hideAllNonBaseMenuItem', 'showAllNonBaseMenuItem', 'showMenuItems', 'hideMenuItems', 'updateAppMessageShareData', 'updateTimelineShareData'] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
            })
          } catch (err) {
            // console.log(err)
            reject(err)
          }
          resolve()
        })
        .catch(err => {
          // console.log(err)
          reject(err)
        })
    })
  },

  /**
   * 微信分享
   * @param {Object} opts   分享参数
   * @param {String} opts.title  分享标题
   * @param {String} opts.desc   分享描述
   * @param {String} opts.imgUrl 分享图标
   */
  weixinshare (opts) {
    if (!this.isInWeixin() && !this.isInDingDing()) return

    // 大会后台默认配置信息
    let storeDefault = {
      title: 'TGO 鲲鹏会 | 助力学员成为更优秀的科技领导者',
      desc: '构建全球化的有技术背景的科技领导者学习成长平台',
      imgUrl: 'https://static001.geekbang.org/resource/image/2b/ba/2b4f20656076991cfe54084dee13c2ba.jpg'
    }

    const defaultOption = {
      title: storeDefault.title || document.title,
      desc: storeDefault.desc || '',
      link: window.location.href,
      success: function () {}
    }

    let option = Object.assign(defaultOption, opts)

    option.imgUrl = option.imgUrl || storeDefault.imgUrl || ''

    // 需在用户可能点击分享按钮前就先调用
    if (this.isInDingDing()) {
      const defaultSuccess = () => {}
      window.dd && window.dd.ready(function () {
        window.dd && window.dd.biz.navigation.setRight({
          show: true, // 控制按钮显示， true 显示， false 隐藏， 默认true
          control: true, // 是否控制点击事件，true 控制，false 不控制， 默认false
          // text: '...',// 控制显示文本，空字符串表示显示默认文本
          onSuccess: function (result) {
            window.dd && window.dd.biz.util.share({
              type: 0, // 分享类型，0:全部组件 默认；1:只能分享到钉钉；2:不能分享，只有刷新按钮
              url: option.link,
              title: option.title,
              content: option.desc || '',
              image: option.imgUrl,
              onSuccess: defaultSuccess
            })
          }
        })
      })
    } else {
      window.wx && window.wx.ready(function () {
        window.wx.updateAppMessageShareData(option)

        window.wx.updateTimelineShareData(option)
      })
    }
  },

  /**
   * 是否是钉钉手机客户端浏览器内
   *
   * @return   {boolean} 如果是钉钉环境则返回 true
   */
  isInDingDing: () => {
    const ua = window.navigator.userAgent
    return !!ua.match(/DingTalk/i)
  },

  /**
   * 是否是微信浏览器内
   *
   * @return   {boolean} 如果是微信环境则返回 true
   */
  isInWeixin: () => {
    const ua = window.navigator.userAgent
    return !!ua.match(/MicroMessenger/i)
  },

  login: () => {
    let href = window.location.href
    window.location.href = `https://account.geekbang.org/infoq/login?redirect=${encodeURIComponent(href)}`
  },

  /**
   * 跳转结算台
   * @param {string} orderInfo JSON 数据
   */
  goPayment (orderInfo) {
    Cookies.set('orderInfo', orderInfo, {
      domain: '.infoq.cn'
    })
    window.location.href = 'https://cashier.infoq.cn/tgo/payment'
  },

  // 去 web 表单系统
  goWebForm (id, needRedirect = true) {
    let href = `https://www.infoq.cn/form/?id=${id}`

    if (needRedirect) href += `&redirect=${encodeURIComponent(window.location.href)}`

    window.location.href = href
  },

  /**
   * @desc 唤起小程序指定页面
   * @param {Object} opt
   * @param {String} opt.appid 小程序 appid
   * @param {String} opt.path 小程序 path 路径
   * @param {String} opt.query 小程序查询参数
   * @param {String} opt.env_version 小程序版本
   */
  goMp (opt) {
    let link = 'https://www.infoq.cn/unit/mp/jump?'

    Object.keys(opt).forEach(key => {
      if (
        key === 'path' ||
        key === 'query'
      ) {
        link += `${key}=${encodeURIComponent(opt[key])}&`
      } else {
        link += `${key}=${opt[key]}&`
      }
    })

    window.location.href = link
  },

  /**
   * @desc 去往 TGO 小程序活动详情页
   * @param {Object} opt
   * @param {Number} opt.id 活动 ID
   * @param {String} opt.env_version 小程序版本
   */
  goMpActivityDetail (opt) {
    let option = {
      appid: config.TGOMpAppId,
      path: 'pages/activitydetail/activitydetail',
      query: `id=${opt.id}`
    }

    if (opt.env_version) {
      option.env_version = opt.env_version
    }

    this.goMp(option)
  },

  toast (message) {
    Vue.prototype.$Message.info({ message, top: '100px', single: true })
  },

  /**
   * @description PC端复制文案
   * @param str 需要复制的文案
   */
  copy (str) {
    return new Promise((resolve, reject) => {
      var cpTxt = str
      if (typeof window.clipboardData !== 'undefined') {
        var clipboardData = window.clipboardData
        clipboardData.setData('Text', cpTxt)
        this.toast('复制成功')
        resolve()
      } else {
        try {
          const input = document.createElement('input')
          document.body.appendChild(input)
          input.setAttribute('value', cpTxt)
          input.select()
          if (document.execCommand('copy')) {
            document.execCommand('copy')
            this.toast('复制成功')
            resolve()
          }
          document.body.removeChild(input)
        } catch (err) {
          // this.error('你的浏览器不支持该操作，请手动复制')
          reject(new Error('你的浏览器不支持该操作，请手动复制'))
        }
      }
    })
  },

  /**
   * 关闭当前窗口
   */
  closeWebPage () {
    if (navigator.userAgent.indexOf('MSIE') > 0) {
      // close IE
      if (navigator.userAgent.indexOf('MSIE 6.0') > 0) {
        window.opener = null
        window.close()
      } else {
        window.open('', '_top')
        window.top.close()
      }
    } else if (navigator.userAgent.indexOf('Firefox') > 0) {
      // close firefox
      window.location.href = 'about:blank '
    } else {
      // close chrome;It is effective when it is only one.
      window.opener = null
      window.open('', '_self')
      window.close()
    }
  },

  formatTime (timestamp, format = 'YYYY年M月D日 H:mm') {
    if (String(timestamp).length === 10) timestamp = `${timestamp}000`
    return moment(Number(timestamp)).format(format)
  },

  ...GA
}
